// extracted by mini-css-extract-plugin
module.exports = {"add-new":"CompaniesAutoComplete_add-new__eG8Mk"};